import React, { PropTypes } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { FormattedMessage } from "react-intl";
import { DEPENDENTS } from "../../../../../../../utils/data/models";
import * as dataActions from "../../../../../../../utils/data/dataActions";

class DependentsNav extends React.Component {
  static getData(action, memberId) {
    const DEPENDENTS_NAV = { ...DEPENDENTS, name: "dependentsNav" };
    const orderBy = ["firstName:asc", "lastName:asc"];
    const filters = [
      `dependentPersons.memberId==${memberId}`,
      DEPENDENTS_NAV.archiveFilter,
    ];
    const fields = "firstName,lastName,dependentPersonId";

    action(
      DEPENDENTS_NAV,
      0,
      0,
      "",
      orderBy,
      filters,
      null,
      { memberId },
      fields
    );
  }

  componentWillMount() {
    if (this.props.dependents.length == 0) {
      DependentsNav.getData(
        this.props.dataActions.getDataList,
        this.props.memberId
      );
    }
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList({
      ...DEPENDENTS,
      name: "dependentsNav",
    });
  }

  getLink(dependentPersonId = "") {
    const base = `/dashboard/clients/${this.props.clientId}/members/${this.props.memberId}/dependents`;
    const id = dependentPersonId ? "/" + dependentPersonId : "";

    return base + id;
  }

  render() {
    return (
      <div className="sub-nav">
        <ul>
          <li>
            <Link
              to={this.getLink()}
              activeClassName={!this.props.dependentId ? "active" : null}
            >
              <FormattedMessage id="dependents.nav.all" />
            </Link>
          </li>
        </ul>
        {this.props.dependents.length > 0 && (
          <ul>
            <li>
              <FormattedMessage id="dependents.nav.coverages" />
            </li>
            {this.props.dependents.map((dependent) => (
              <li key={dependent.dependentPersonId}>
                <Link
                  to={this.getLink(dependent.dependentPersonId)}
                  activeClassName="active"
                >
                  <span>{`${dependent.lastName} ${dependent.firstName[0]}.`}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

DependentsNav.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  dataActions: PropTypes.object,
  dependentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dependents: PropTypes.array,
  memberId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
};

function mapStateToProps(state) {
  const dependents = state.data.dependentsNav || {};
  return {
    dependents: dependents.items || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DependentsNav);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/DependentsNav.js